import { http, type ApiEnvelope } from "./http";

export interface SystemBootstrap {
  application: { name: string; version: string };
  context: {
    currentProject: { id: string; code: string; name: string } | null;
    businessDate: string;
    timezone: string;
  };
  user: {
    id: string;
    displayName: string;
    roles: string[];
    permissions: string[];
  };
  projects: Array<{ id: string; code: string; name: string; status: string }>;
  dictionaries: Record<
    string,
    Array<{ value: string; label: string; metadata?: unknown }>
  >;
  features: {
    ai: boolean;
    crm: boolean;
    crmSaas: boolean;
    personalViews: boolean;
    reports: boolean;
    notifications: boolean;
  };
}

export async function getSystemBootstrap() {
  return http.get<never, ApiEnvelope<SystemBootstrap>>("/system/bootstrap");
}
